import axios from 'axios';

export default {
    markDelivered(employeeId, orderIds) {
        return axios.post('/order/markDelivered/', {
            employeeId,
            orderIds,
        });
    },
    date(deliveryDateId) {
        return axios.post('/delivery/date/', {
            deliverydate: deliveryDateId,
        });
    },
    dateAndProducts(dateId) {
        return axios.post('/delivery/dateAndProducts', {
            deliverydate: dateId,
        });
    },
    updateDeliverySorting(dateId, customerIds) {
        return axios.post('/delivery/updateDeliverySorting/', {
            deliveryDateId: dateId,
            customerIds: customerIds,
        });
    },
    listTrucks() {
        return axios.post('/delivery/listTrucks/');
    },
    listDeliveryMethods() {
        return axios.post('/delivery/listDeliveryMethods/');
    },
    listDrivers() {
        return axios.post('/user/listDrivers/');
    },
    fetchOverview(payload) {
        return axios.post('/delivery/overviewDeliveryDate/', payload);
    },
    deleteDate(dateId) {
        return axios.post('/delivery/deleteDate/', {
            deliverydate: dateId,
        });
    },
    updateInvoiced(deliveryDateId, invoiced) {
        return axios.post('/delivery/updateInvoiced/', {
            deliverydateId: deliveryDateId,
            invoiced: invoiced,
        });
    },
    update(payload) {
        return axios.post('/delivery/updateDate', payload);
    },
    add(payload) {
        return axios.post('/delivery/addDate', payload);
    },
    listDeliveryDatesForDeliveryMethod(
        deliveryMethod,
        onlyEmpty,
        inFuture,
        deliverydate
    ) {
        return axios.post('/delivery/listDeliveryDatesForDeliveryMethod', {
            deliveryMethod,
            onlyEmpty,
            inFuture,
            deliverydate,
        });
    },
    fetchCapacityForDeliveryDateDate(toDate) {
        return axios.post('/delivery/fetchCapacityForDeliveryDateDate', {
            toDate,
        });
    },

    createRecurringTrip(payload) {
        return axios.post('/delivery/createRecurringTrip', payload);
    },

    updateRecurringInstance(deliverydateId, scope, updates) {
        return axios.post('/delivery/updateRecurringInstance', {
            deliverydateId,
            scope, // 'this' or 'this_and_following'
            ...updates
        });
    },

    getRecurringConfig(recurringConfigId) {
        return axios.post('/delivery/getRecurringConfig', {
            recurringConfigId
        });
    },

    previewRecurringTrip(payload) {
        return axios.post('/delivery/previewRecurringTrip', payload);
    },

    deleteRecurringInstance(deliverydateId, scope) {
        return axios.post('/delivery/deleteRecurringInstance', {
            deliverydateId,
            scope // 'this' or 'this_and_following'
        });
    }
};
